/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelPlantillaofPersonnelGet$Params {
  office_id?: string;
}

export function apiExcelExcelPlantillaofPersonnelGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelPlantillaofPersonnelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelPlantillaofPersonnelGet.PATH, 'get');
  if (params) {
    rb.query('office_id', params.office_id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelPlantillaofPersonnelGet.PATH = '/api/Excel/Excel_PlantillaofPersonnel';
